export class MoiCommentPermissionModel {
    canSetProgress: boolean;
    canAddComment: boolean;

    canSetProgressOnClose: boolean;
    canSetProgressOnReopen: boolean;
}
